import React from 'react';
export function HeroSection() {
  return <section className="relative w-full bg-white pt-10 pb-1 px-4 overflow-hidden" data-id="element-84">
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-85">
        <h1 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-3 leading-none text-[#DEA0C0]" data-id="element-86">
          KIT APRENDIZAJE EN CASA
        </h1>

        <h2 className="md:text-lg font-medium mb-0 max-w-2xl mx-auto text-[18px] leading-snug text-[#000000] mt-1" data-id="element-87">
          Guia practica con las herramientas que necesitas para comprender y
          ayudar a tu hijo
        </h2>

        <div className="relative w-full max-w-[400px] mx-auto -mt-1 mb-1" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/5ATUSBLgjDJtTdNCTeh9gt/imagen_principal_pagina.png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-89" />
        </div>

        <div className="bg-white/60 backdrop-blur-md border border-pink-200 rounded-xl p-2 mb-0 max-w-3xl mx-auto shadow-lg" data-id="element-90">
          <p className="text-lg md:text-xl text-rose-900 mb-0 font-[600]" data-id="element-91">
            El problema no es tu hijo, es la forma en que le están enseñando.
            Entre el cansancio, el tiempo y la paciencia, hay algo que se está
            escapando y se nota en cada tarea. Y eso… se puede cambiar.
          </p>
        </div>
      </div>
    </section>;
}